import {Stack, styled} from '@mui/material';

export const ConfirmationFooter = styled(Stack)`
	${({theme}) => theme.breakpoints.down('md')} {
		border-top: 1px solid ${({theme}) => theme.palette.other.outlineBorder};
		background-color: ${({theme}) => theme.palette.background.paper};
		position: fixed;
		padding: 8px 16px;
		bottom: 0;
		right: 0;
		left: 0;
	}
`;
